import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import PropTypes from 'prop-types';

MenuActionDropdown.propTypes = {
    menuAction: PropTypes.array,
};

function MenuActionDropdown({ menuAction = [] }) {
    const visibleActions = menuAction.filter(action => action.show);

    const mainActions = visibleActions.slice(0, 2);
    const dropdownActions = visibleActions.slice(2);

    return (
        <div className="d-flex gap-2 align-items-center">
            {mainActions.map((action, index) => (
                <div key={index}>
                    <KTTooltip offset={[0, 0]} text={action?.text}>
                        <a
                            className="btn btn-sm btn-clean btn-icon"
                            onClick={() => {
                                action.click();
                            }}
                        >
                            {action?.iconElement}
                        </a>
                    </KTTooltip>
                </div>
            ))}

            {dropdownActions.length > 0 && (
                <VITableRowDropDown
                    toggleElement={
                        <a className="btn btn-sm btn-clean btn-icon p-0">
                            <i
                                className="fa-solid fa-ellipsis"
                                style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                            />
                        </a>
                    }
                    menuItem={dropdownActions.map(action => ({
                        iconElement: action.iconElement,
                        text: action.text,
                        click: action.click,
                        show: true
                    }))}
                />
            )}
        </div>
    );
}

export default MenuActionDropdown;